import type { IAction } from '../../action/IAction'
import type { WorkOrder } from '../WorkOrder'
import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class UnlinkWorkOrderTaskArgs extends ActionArgs {
  @Field(() => String)
  workOrderId: string

  @Field(() => [String])
  taskIds: string[]
}

export interface IUnlinkNewWorkOrderTask extends IAction<WorkOrder, UnlinkWorkOrderTaskArgs> {}
